import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { IonicModule } from "@ionic/angular";
import { ScenarioPage } from "./scenario.page";
import { TranslateModule } from "@ngx-translate/core";
import { NgSelectModule } from "@ng-select/ng-select";
import { TranslateTriggerNamesModule } from "src/app/pages/scenario/pipes/translate-trigger-names/translate-trigger-names.module";

@NgModule({
  imports: [CommonModule, IonicModule, FormsModule, ReactiveFormsModule, TranslateModule, NgSelectModule, TranslateTriggerNamesModule],
  declarations: [ScenarioPage],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class ScenarioPageModule {}
